export default {
    getOtherDetailDisplayText(fieldId) {
        switch(fieldId) {
           case 'WEBSITE': {
               return 'Website URL';
           }
           break;
           case 'LINKEDIN': {
               return 'LinkedIn URL';
           }
           break;
           case 'FACEBOOK': {
               return 'Facebook URL';
           }
           break;
           case 'INSTAGRAM': {
               return 'Instagram Handle';
           }
           break;
           case 'TWITTER': {
               return 'Twitter Handle';
           }
           break;
           case 'YOUTUBE': {
               return 'YouTube Channel';
           }
           break;
           case 'PHONE': {
                return 'Phone Number';
            }
            break;
            case 'EMAIL': {
                return 'Email';
            }
            break;
            case 'ADDRESS': {
                return 'Address';
            }
            break;
            case 'TOLL_FREE': {
                return 'Toll Free/ Local Rate Number';
            }
           case 'OTHER_LINK': {
               return 'Other Link';
           }
           break;
           default: {
               return '';
           }
           break;
       }
   },
   getOtherDetailPrefix(fieldId) {
        switch(fieldId) {
           case 'WEBSITE': {
               return this.urlPrefixes.urlPrefix;
           }
           break;
           case 'LINKEDIN': {
               return this.urlPrefixes.linkedinUrlPrefix;
           }
           break;
           case 'FACEBOOK': {
               return this.urlPrefixes.facebookUrlPrefix;
           }
           break;
           case 'INSTAGRAM': {
               return this.urlPrefixes.instagramUrlPrefix;
           }
           break;
           case 'TWITTER': {
               return this.urlPrefixes.twitterUrlPrefix;
           }
           break;
           case 'YOUTUBE': {
               return this.urlPrefixes.youtubeurlPrefix;
           }
           break;
           case 'PHONE': {
            return '';
            }
            break;
            case 'EMAIL': {
                return '';
            }
            break;
            case 'ADDRESS': {
                return '';
            }
            break;
            case 'TOLL_FREE': {
                return '';
            }
            break;
           case 'OTHER_LINK': {
               return this.urlPrefixes.urlPrefix;
           }
           break;
           default: {
               return '';
           }
           break;
       }
   },
   getOtherDetailPrependIcon(fieldId) {
        switch(fieldId) {
           case 'WEBSITE': {
               return 'public';
           }
           break;
           case 'LINKEDIN': {
               return 'mdi-linkedin';
           }
           break;
           case 'FACEBOOK': {
               return 'mdi-facebook';
           }
           break;
           case 'INSTAGRAM': {
               return 'mdi-instagram';
           }
           break;
           case 'TWITTER': {
               return 'mdi-twitter';
           }
           break;
           case 'YOUTUBE': {
               return 'mdi-youtube';
           }
           break;
           case 'PHONE': {
                return 'mdi-phone';
            }
            break;
            case 'TOLL_FREE': {
                return 'mdi-face-agent';
            }
            break;
            case 'EMAIL': {
                return 'mdi-email';
            }
            break;
            case 'ADDRESS': {
                return 'mdi-map-marker';
            }
            break;
           case 'OTHER_LINK': {
               return 'insert_link';
           }
           break;
           default: {
               return '';
           }
           break;
       }
   },
   getOtherDetailInputPlaceholder(fieldId) {
        switch(fieldId) {
           case 'WEBSITE': {
               return ' ';
           }
           break;
           case 'LINKEDIN': {
               return 'yourhandle';
           }
           break;
           case 'FACEBOOK': {
               return 'yourhandle';
           }
           break;
           case 'INSTAGRAM': {
               return 'yourhandle';
           }
           break;
           case 'TWITTER': {
               return 'yourhandle';
           }
           break;
           case 'YOUTUBE': {
               return 'yourchannel';
           }
           break;
           case 'OTHER_LINK': {
               return ' ';
           }
           break;
           default: {
               return ' ';
           }
           break;
       }
   },
   getOtherDetailHint(fieldId) {
        switch(fieldId) {
           case 'WEBSITE': {
               return 'e.g. ' + this.urlPrefixes.urlPrefix + 'www.pappyon.com';
           }
           break;
           case 'LINKEDIN': {
               return 'e.g. ' + this.urlPrefixes.linkedinUrlPrefix + 'pappyon';
           }
           break;
           case 'FACEBOOK': {
               return 'e.g. ' + this.urlPrefixes.facebookUrlPrefix + 'pappyon';
           }
           break;
           case 'INSTAGRAM': {
               return 'e.g. ' + this.urlPrefixes.instagramUrlPrefix + 'pappyon';
           }
           break;
           case 'TWITTER': {
               return 'e.g. ' + this.urlPrefixes.twitterUrlPrefix + 'pappyon';
           }
           break;
           case 'YOUTUBE': {
               return 'e.g. ' + this.urlPrefixes.youtubeurlPrefix + 'pappyon';
           }
           break;
           case 'OTHER_LINK': {
               return 'e.g. ' + this.urlPrefixes.urlPrefix + 'www.pappyon.com';
           }
           break;
           default: {
               return '';
           }
           break;
       }
   },
   getOtherDetailIcon(fieldId){
       switch(fieldId){

            case 'WEBSITE': {
                return 'website-icon.svg';
            }
            break;
            case 'LINKEDIN': {
                return 'linkedin-icon.svg';
            }
            break;
            case 'FACEBOOK': {
                return 'facebook-icon.svg';
            }
            break;
            case 'INSTAGRAM': {
                return 'instagram-icon.svg';
            }
            break;
            case 'TWITTER': {
                return 'twitter-icon.svg';
            }
            break;
            case 'YOUTUBE': {
                return 'youtube-icon.svg';
            }
            break;
            case 'PHONE': {
                 return 'call-icon.svg';
             }
             break;
             case 'TOLL_FREE': {
                 return 'toll-free-icon.svg';
             }
             break;
             case 'EMAIL': {
                 return 'email-icon.svg';
             }
             break;
             case 'ADDRESS': {
                 return 'location-icon.svg';
             }
             break;
            case 'OTHER_LINK': {
                return 'other-link-icon.svg';
            }
            break;
            default: {
                return '';
            }
            break;
        }

   },
}